import { render, staticRenderFns } from "./OnlineUpdate.vue?vue&type=template&id=1625a840&scoped=true&"
import script from "./OnlineUpdate.vue?vue&type=script&lang=js&"
export * from "./OnlineUpdate.vue?vue&type=script&lang=js&"
import style0 from "./OnlineUpdate.vue?vue&type=style&index=0&id=1625a840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1625a840",
  null
  
)

export default component.exports